<template>
    <div class="mt-6 content">
        <h3 class="has-text-white"><i class="fad fa-fw fa-id-badge mr-3"></i>Your Registration</h3>

        <p class="mt-6 has-text-white" v-if="!registration.id"><i class="fas fa-spin fa-spinner fa-fw mr-3"></i>Please wait. Loading registration...</p>

        <div v-else class="mt-6 pb-6" ref="top">
            <ui-card>
                <div class="details-box">
                    <div class="detail">
                        <div class="header">Conference</div>
                        <div class="info">{{ registration.conference.title }}</div>
                    </div>
                    <div class="detail">
                        <div class="header">Dates</div>
                        <div class="info">{{ confDates }}</div>
                    </div>
                    <div class="detail">
                        <div class="header">Location</div>
                        <div class="info">{{ registration.conference.location }}</div>
                    </div>
                    <div class="detail">
                        <div class="header">Registration Date</div>
                        <div class="info">{{ registration.created_at | moment('MMMM D, YYYY') }}</div>
                    </div>
                    <div class="detail">
                        <div class="header">Registration Type</div>
                        <div class="info">{{ registration.reg_type.title }}</div>
                    </div>
                    <div class="detail" v-if="registration.total_paid">
                        <div class="header">Payment</div>
                        <div class="info">
                            <div>{{ registration.total_paid | currency }} by {{registration.payment_type.replace('cc', 'Credit Card').replace('po', 'Purchase Order')}}</div>
                            <div v-if="registration.intent_id" class="mt-3 mb-2">
                                <b-button @click="getReceipt" type="is-info" size="is-small" rounded><i class="fad fa-file-invoice-dollar mr-2"></i>View Receipt</b-button>
                            </div>
                        </div>
                    </div>

<!--                        <div class="detail">-->
<!--                            <div class="header">Registration Type</div>-->
<!--                            <div class="info"><json-viewer :value="registration"></json-viewer></div>-->
<!--                        </div>-->
                </div>
            </ui-card>

            <removal-card class="mt-5" kind="registration" :endpoint="`app/registrations/${registration.id}/removal`" :name="registration.conference.title" :payment-note="removalPaymentNote" @removed="onRemoved"/>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import moment from "moment";
    import UiCard from "../../components/UiCard.vue";
    import RemovalCard from "../../components/RemovalCard.vue";
    import {client as http} from "../../http_client";

    export default {
        components: {UiCard, RemovalCard},
        computed: {
            ...mapGetters(['currentUser']),
            ...mapGetters(['registration']),
            isPreRegistration: function() {
                return moment().isBefore(moment(this.registration.conference.start_at));
            },
            removalPaymentNote: function() {
                const paid = parseFloat(this.registration.total_paid) || 0;
                return paid > 0 ? `The ${this.$options.filters.currency(paid)} paid for this registration will not be refunded.` : '';
            },
            confDates: function() {
                let s = moment(this.registration.conference.start_at);
                let e = moment(this.registration.conference.end_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMMM D, YYYY');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMMM D - ') + e.format('D, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D - ') + e.format('MMM D, YYYY');
                } else {
                    return s.format('MMM D, YYYY - ') + e.format('MMM D, YYYY');
                }
            },
        },
        methods: {
            onRemoved: function() {
                this.$store.dispatch('getRegistrations');
                this.$router.push({name: 'dashboard'});
            },
            getReceipt: function() {
                http.get('/providers/stripe/v1/receipt/' + this.registration.intent_id).then(response => {
                    window.open(response.data.url, '_blank');
                }).catch(err => {

                });
            }
        },
    };
</script>

<style lang="scss" scoped>
    .details-box {
        background-color: #fdfdfd;
        border-radius: 8px;
        border: 1px solid #e0e2e8;

        .detail {
            padding: 0.5rem 1rem;
            border-bottom: 1px solid #e0e2e8;

            &:last-child {
                border-bottom: none;
            }

            .header {
                font-size: 1rem;
                color: #224C74;
                font-weight: bold;
            }

            .info {
                font-size: 1.1rem;
            }
        }
    }
</style>
